// LIBRERIE/IMPORTS
import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import { useTranslation } from "react-i18next";

interface SubHeaderCarouselProps {
  agencyName: string;
}

const SubHeaderCarousel: React.FC<SubHeaderCarouselProps> = ({ agencyName }) => {

    const { t } = useTranslation();

    return (
    <Carousel fade prevLabel={false} nextLabel={false} keyboard={true}>
        <Carousel.Item>
            <img src="/assets/images/slider/01.jpg" alt="sfondo1" />
            <Carousel.Caption>
                <h3>{agencyName}</h3>
                <p>{t('subHeader.carouselPara1')}</p>
            </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
            <img src="/assets/images/slider/02.jpg" alt="sfondo2" />
            <Carousel.Caption>
                <h3>{agencyName}</h3>
                <p>{t('subHeader.carouselPara2')}</p>
            </Carousel.Caption>
        </Carousel.Item>
    </Carousel>
    );
};

export default SubHeaderCarousel;